import { styled } from '@mui/material'

import { BaseContainer } from '../../configs/styles/BaseGrid'

export const DialogButtons = styled(BaseContainer)``

export const DialogContent = styled(BaseContainer)`
  &.MuiGrid-container {
    ${props => props.theme.breakpoints.only('sm')} {
      padding: 32px 16px;
    }

    ${props => props.theme.breakpoints.only('xs')} {
      padding: 32px 0;
    }
  }
`

export const DialogIcon = styled('img')`
  pointer-events: none;
  user-select: none;
  width: 64px;
`

export const DialogMessage = styled(BaseContainer)`
  &.MuiGrid-container {
    text-align: center;
  }
`
